import {Box, Tooltip} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

const COUNTRY_SEARCH_HINT = "Search by country code, e.g. DE, NL";

export function CountryColumnHeader() {
    return (
        <Tooltip title={COUNTRY_SEARCH_HINT}>
            <Box component="span" sx={{display: 'inline-flex', alignItems: 'center', gap: 0.5}}>
                Country
                <Box
                    component="span"
                    aria-label={COUNTRY_SEARCH_HINT}
                    onMouseDown={(event) => event.stopPropagation()}
                    onClick={(event) => event.stopPropagation()}
                    sx={{display: 'inline-flex', color: 'text.secondary', lineHeight: 0}}
                >
                    <HelpOutlineIcon sx={{fontSize: 16}}/>
                </Box>
            </Box>
        </Tooltip>
    );
}
